let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jxBJT")).then(() => parcelRequire('dS4IL'));